<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { PopoverContentEmits, PopoverContentProps } from 'reka-ui';
  import { PopoverContent, PopoverPortal, useForwardPropsEmits } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<PopoverContentProps & { class?: HTMLAttributes['class'] }>(),
    {
      align: 'center',
      avoidCollisions: true,
      collisionPadding: 8,
      hideWhenDetached: true,
      prioritizePosition: true,
      sideOffset: 4,
    },
  );

  const emits = defineEmits<PopoverContentEmits>();

  defineOptions({
    inheritAttrs: false,
  });

  const delegatedProps = reactiveOmit(props, 'class');

  const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <PopoverPortal>
    <PopoverContent
      data-slot="popover-content"
      v-bind="{ ...$attrs, ...forwarded }"
      hide-when-detached
      :class="
        cn(
          'bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit min-w-32 max-w-84 rounded-sm border p-4 shadow-md origin-(--reka-popover-content-transform-origin) outline-hidden',
          props.class,
        )
      "
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
